module.exports = __webpack_public_path__ + "static/img/img_form_2@2x_zh_cn.e073afee.png";